const styles = (theme) => ({
  loader: {
    fill: theme.palette.primary.white,
    color: theme.palette.primary.white,
  },
});

export default styles;
